import { Link } from 'react-router-dom'
import { useManuals, useModules } from '../api/queries'
import { Card } from './ui'

/**
 * Manualerne der hører til det, man står med (docs/DECISIONS.md beslutning 063).
 *
 * <b>Det er hele pointen med koblingerne.</b> Et bibliotek, man selv skal huske
 * at slå op i, bliver ikke brugt af en mand i et teknikrum - men ligger
 * manualen på enhedens side, når han lige har scannet mærkatet, bliver den
 * læst.
 *
 * Kortet vises kun, når der faktisk er noget. Et tomt "Manualer" på hver
 * eneste enhed lærer folk at overse overskriften - og så ser de den heller ikke
 * den dag, der står noget.
 */
export function RelatedManualsCard({
  deviceType,
  templateId,
  title
}: {
  /** Enhedstypen, fra enhedens side. */
  deviceType?: string | null
  /** Procedureskabelonen sagen blev oprettet fra. */
  templateId?: number | null
  title?: string
}) {
  const { data: modules } = useModules()
  const enabled = modules?.some((m) => m.key === 'manuals' && m.enabled) ?? false

  const { data } = useManuals({
    deviceType: deviceType ?? undefined,
    templateId: templateId ?? undefined,
    // Uden en af de to ville forespoergslen hente HELE biblioteket og vise det
    // som "hoerer til her", hvilket ville vaere loegn.
    enabled: enabled && Boolean(deviceType || templateId)
  })

  if (!data || data.length === 0) return null

  return (
    <Card title={title ?? `Manualer (${data.length})`}>
      <div className="stack" style={{ gap: 2 }}>
        {data.map((manual) => (
          <Link key={manual.id} className="row row--between device-row" to={`/manuals/${manual.id}`}>
            <div style={{ minWidth: 0 }}>
              <div className="small">
                {manual.kind === 'file' ? '📄' : '📝'} {manual.title}
              </div>
              {manual.summary && <div className="tiny muted">{manual.summary}</div>}
            </div>
            <div className="tiny muted" style={{ whiteSpace: 'nowrap' }}>
              {manual.createdBy?.displayName ?? 'Ukendt'}
            </div>
          </Link>
        ))}
      </div>
    </Card>
  )
}
